import { Breadcrumb } from "antd";
import {
  BreadcrumbItemType,
  BreadcrumbSeparatorType,
} from "antd/es/breadcrumb/Breadcrumb";
import { Link } from "react-router-dom";
interface IBreadcrumbItem {
  title: string;
  path?: string;
}
function itemRender(
  currentRoute: Partial<BreadcrumbItemType & BreadcrumbSeparatorType>,
  _: IBreadcrumbItem,
  items: Partial<BreadcrumbItemType & BreadcrumbSeparatorType>[]
) {
  const isLast = currentRoute?.path === items[items.length - 1]?.path;
  if (currentRoute.path === "/") {
    return <Link to={"/"}>{currentRoute.title}</Link>;
  }
  return isLast ? (
    <span>{currentRoute?.title}</span>
  ) : (
    <Link to={currentRoute.path || "/"}>{currentRoute.title}</Link>
  );
}
interface INarinBreadcrumb {
  items: IBreadcrumbItem[];
}
const NarinBreadcrumb = ({ items }: INarinBreadcrumb) => {
  return (
    <Breadcrumb
      className="pt-4 mb-4 px-4"
      separator=">"
      itemRender={itemRender}
      items={items}
    />
  );
};
export default NarinBreadcrumb;
